import { render, staticRenderFns } from "./ResourceOccupationCard.vue?vue&type=template&id=0a0b1bd8&scoped=true&"
import script from "./ResourceOccupationCard.vue?vue&type=script&lang=js&"
export * from "./ResourceOccupationCard.vue?vue&type=script&lang=js&"
import style0 from "./ResourceOccupationCard.vue?vue&type=style&index=0&id=0a0b1bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b1bd8",
  null
  
)

export default component.exports